<template>
  <v-app>
    <Def>
      <v-container fluid style="margin-top:100px; width:90%;">
        <v-row>
          <v-col cols="6" class="pl-0">
            <Space>
              <v-row>
                <v-col :cols="cols3">
                  <div style="font-size:0.65vw;">Вуз</div>
                </v-col>
                <v-col :cols="cols32">
                  <div style="font-size:0.75vw;">{{$ls.get("BYZ")}}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">Активная образовательная программа</v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">НАПРАВЛЕНИЕ/ СПЕЦИАЛЬНОСТЬ:</v-col>
                <v-col :cols="cols32">
                  <div style="font-size:0.75vw;">{{$ls.get("way")}}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">ПРОФИЛЬ:</v-col>
                <v-col :cols="cols32" style="font-size:0.75vw;">{{$ls.get("prof")}}</v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">КУРС</v-col>
                <v-col :cols="cols32" style="font-size:0.75vw;">{{$ls.get("cours")}}</v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">НАВЫКИ</v-col>
                <v-col :cols="cols32" style="font-size:0.75vw;">{{text}}</v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">ДЕЯТЕЛЬНОСТЬ</v-col>
                <v-col :cols="cols32">
                  <div style="font-size:0.75vw;">{{$ls.get("activity")}}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col :cols="cols3" style="font-size:0.65vw;">ЖЕЛАЕМАЯ ВАКАНСИЯ В РАБОТЕ</v-col>
                <v-col :cols="cols32" style="font-size:0.75vw;">{{$ls.get("vacancy")}}</v-col>
              </v-row>
            </Space>
          </v-col>
          <v-col cols="6" class="pr-0">
            <Space>
              <v-col cols="12" class="pb-0">
                <v-row justify="center">
                  <v-avatar color="orange" size="84">
                    <v-img :src="$ls.get('avatar')"></v-img>
                  </v-avatar>
                </v-row>
                <v-row class="font-weight-bold" justify="center" style="font-size:0.9vw">{{Fio}}</v-row>

                <v-row justify="center" style="font-size:0.85vw">
                  <v-col cols="3" class="pb-0 pt-0">
                    <Ndiv :Data="1" :Title="'законченных проекта в роли участника'"></Ndiv>
                  </v-col>
                  <v-col cols="3" class="pb-0 pt-0">
                    <Ndiv :Data="1 + 1" :Title="'собственный активный проект'"></Ndiv>
                  </v-col>
                  <v-col cols="3" class="pb-0 pt-0">
                    <Ndiv :Data="1 + 2" :Title="'предложений о стажировке или работы'"></Ndiv>
                  </v-col>
                </v-row>
                <v-row class="mt-n5">
                  <v-col cols="6" class="pb-0 pt-0">
                    <v-row>
                      <v-col cols="12" style="font-size:0.8vw">
                        <v-row>
                          <v-col cols="4">ГОРОД</v-col>
                          <v-col cols="8" class="font-weight-bold">{{$ls.get("city")}}</v-col>
                        </v-row>
                        <v-row class="mt-n3">
                          <v-col cols="4">ЭЛ.ПОЧТА</v-col>
                          <v-col cols="8" class="font-weight-bold">{{$ls.get("email")}}</v-col>
                        </v-row>
                        <v-row class="mt-n3">
                          <v-col cols="4">ТЕЛЕФОН</v-col>
                          <v-col cols="8" class="font-weight-bold">{{$ls.get("nomberPhone")}}</v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6" align-self="end">
                    <v-row justify="end" align="end">Рейтинг: 10</v-row>
                    <v-row justify="end" align="end">
                      <v-col cols="6" class="pr-0">
                        <v-btn color="#5B98F1" width="100%" rounded depressed>
                          <v-icon size="26">question_answer</v-icon>
                          <p
                            class="black--text mt-3 text-capitalize"
                            style="font-size:0.8vw;"
                          >Написать</p>
                        </v-btn>
                      </v-col>
                      <v-col cols="6" class="pr-0">
                        <v-btn color="#FFCF36" width="100%" rounded outlined>
                          <v-icon size="26">thumbs_up_down</v-icon>
                          <p
                            class="black--text mt-3 text-capitalize"
                            style="font-size:0.8vw;"
                          >Оставить отзыв</p>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </Space>
          </v-col>
        </v-row>
        <v-row class="pt-2">
          <Space>
            <v-row>Достижения</v-row>
            <v-row>
              <v-sheet color="#F1F4FB" max-width="100%">
                <v-slide-group center-active v-model="model" class="pa-4" show-arrows>
                  <v-slide-item v-for="n in 26" :key="n" v-slot:default="{ active, toggle }">
                    <v-card
                      :color="active ? 'primary' : 'grey lighten-1'"
                      class="ma-4"
                      height="100"
                      width="100"
                      @click="toggle"
                    >
                      <v-img
                        v-if="!active && n%2 == 1"
                        height="100%"
                        src="https://avatarko.ru/img/kartinka/33/multfilm_lyagushka_32117.jpg"
                      ></v-img>
                      <v-row
                        v-if="!active && n%2 == 0"
                        class="fill-height"
                        align="center"
                        justify="center"
                      >
                        <v-scale-transition>
                          <v-card
                            width="100"
                            class="text-center"
                            color="rgba(255,0,0,0)"
                            outlined
                          >Хакатон</v-card>
                        </v-scale-transition>
                      </v-row>
                      <v-row v-if="active" class="fill-height" align="center" justify="center">
                        <v-scale-transition>
                          <v-card
                            width="100"
                            class="text-center"
                            color="rgba(255,0,0,0)"
                            outlined
                          >Выиграли кубок</v-card>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>

                <v-expand-transition>
                  <v-sheet v-if="model != null" color="#F1F4FB" class="mx-auto" tile>
                    <v-divider></v-divider>
                    <v-row class="text-center" align="center" justify="center">
                      <v-card outlined color="#F1F4FB">
                        <h3 class="title">Подробное описание достижения {{model}}</h3>
                      </v-card>
                    </v-row>
                  </v-sheet>
                </v-expand-transition>
              </v-sheet>
            </v-row>
          </Space>
        </v-row>
        <v-row class="mt-5">
          <Space>
            <v-row>
              <v-col cols="4">
                <v-card-text>
                  <v-treeview
                    style="font-size:0.9vw"
                    v-model="tree"
                    :items="items"
                    selected-color="indigo"
                    open-on-click
                    selectable
                    return-object
                    expand-icon="mdi-chevron-down"
                    on-icon="mdi-bookmark"
                    off-icon="mdi-bookmark-outline"
                    indeterminate-icon="mdi-bookmark-minus"
                  ></v-treeview>
                </v-card-text>
              </v-col>

              <v-divider vertical></v-divider>

              <v-col>
                <v-card-text>
                  <div
                    v-if="tree.length === 0"
                    key="title"
                    class="title font-weight-light grey--text text-center"
                  >Выберете отзыв/Будет лучше</div>

                  <div style="font-size:0.8vw" v-for="(selection, i) in tree" :key="i">
                    <h1>{{selection.name}}</h1>
                    <div v-for="n in arr(selection.name)" :key="n">
                      <v-row>
                        <v-col>{{n}}</v-col>
                        <v-col align="end">Оценка:9</v-col>
                      </v-row>
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </Space>
        </v-row>
      </v-container>
    </Def>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    model: null,
    cols3: 4,
    cols32: 8,
    models: [],
    tree: [
      {
        id: 3,
        name: "Фарида",
      },
    ],
    types: [],
    items: [
      {
        id: 1,
        name: "Отзывы :",
        children: [
          { id: 2, name: "Студентов", children: [{ id: 3, name: "Фарида" }] },
          {
            id: 4,
            name: "Предприятий",
            children: [{ id: 5, name: "Газпром" }],
          },
        ],
      },
    ],
    Otz: [
      {
        name: "Фарида",
        title: ["Всё супер", "Поработала бы снова"],
      },
      {
        name: "Газпром",
        title: ["Всё отлично"],
      },
    ],
  }),
  computed: {
    shouldShowTree() {
      return this.breweries.length > 0 && !this.isLoading;
    },
    Fio() {
      if (this.Otc != "") {
        return this.LastName + " " + this.Name + " " + this.Otc;
      } else {
        return this.LastName + " " + this.Name;
      }
    },
    text() {
      var a = "";
      if (this.models != null) {
        for (let i = 0; i < this.models.length; i++) {
          if (i + 1 < this.models.length) {
            a += this.models[i] + ", ";
          } else {
            a += this.models[i];
          }
        }
        return a;
      } else {
        return "";
      }
    },
  },
  watch: {
    breweries(val) {
      this.types = val
        .reduce((acc, cur) => {
          const type = cur.brewery_type;

          if (!acc.includes(type)) acc.push(type);

          return acc;
        }, [])
        .sort();
    },
  },
  created() {
    var a = this.$ls.get("fio").split("_");
    this.LastName = a[0];
    this.Name = a[1];
    this.Otc = a[2];
    this.models = this.$ls.get("skills");
  },
  methods: {
    arr(e) {
      let a = [];
      for (var i = 0; i < this.Otz.length; i++) {
        if (e == this.Otz[i].name) {
          for (var j = 0; j < this.Otz[i].title.length; j++) {
            a.push(this.Otz[i].title[j]);
          }
        }
      }
      return a;
    },
    getChildren(type) {
      const breweries = [];

      for (const brewery of this.breweries) {
        if (brewery.brewery_type !== type) continue;

        breweries.push({
          ...brewery,
          name: this.getName(brewery.name),
        });
      }

      return breweries.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
    },
    getName(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
    },
  },
};
</script>